import { Timer } from "lucide-react";

const BALL_STYLE = {
  "0": "bg-slate-800 text-slate-400 border-slate-700",
  "1": "bg-slate-700/60 text-slate-200 border-slate-600",
  "2": "bg-slate-700/60 text-slate-200 border-slate-600",
  "3": "bg-slate-700/60 text-slate-200 border-slate-600",
  "4": "bg-amber-500/20 text-amber-300 border-amber-500/40",
  "6": "bg-purple-500/20 text-purple-300 border-purple-500/40",
  "W": "bg-rose-500/25 text-rose-300 border-rose-500/40",
  "Wd": "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  "Nb": "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
};

export default function LiveOverTimeline({ match }) {
  const balls = match.current_over_balls || [];
  const overNo = match.overs_completed + 1;
  const legal = balls.filter((b) => b !== "Wd" && b !== "Nb").length;
  const remaining = Math.max(0, 6 - legal);

  return (
    <div className="tile p-6 grain">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Timer className="w-4 h-4 text-amber-400" />
          <div className="section-label">Current over</div>
        </div>
        <div className="font-mono-data text-amber-400 text-xl">Over #{overNo}</div>
      </div>

      <div className="flex items-center gap-2 mb-3">
        {Array.from({ length: 6 }).map((_, i) => {
          const b = balls.filter((x) => x !== "Wd" && x !== "Nb")[i];
          return (
            <div
              key={i}
              className={`ball-chip ${b ? BALL_STYLE[b] || "bg-slate-800" : "bg-transparent border-dashed"}`}
            >
              {b || "•"}
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between text-xs">
        <span className="text-slate-400">Extras this over: <span className="font-mono-data text-cyan-300">{balls.filter((x) => x === "Wd" || x === "Nb").length}</span></span>
        <span className="text-slate-400">Legal balls remaining: <span className="font-mono-data text-amber-400">{remaining}</span></span>
      </div>
    </div>
  );
}
